import { httpGET } from './utils'
import { OPENROUTESERVICE_URL, PHOTON_SEARCH_URL } from './constants'
import { open_route_service_api_key } from './api_keys'

export const GeocodeService = {
  ORS: 0,  // Openroute Services
  PHOTON: 1,  // Photon (...)
};

const OpenRouteServicesGeoCoder = {

  geocode(localization, focus_lat = null, focus_lon = null) {
    let url = OPENROUTESERVICE_URL + "/geocode/autocomplete?api_key=" + open_route_service_api_key
                                  + "&text=" + encodeURIComponent(localization);
    if (focus_lat && focus_lon) {
      url += "&focus.point.lat=" + focus_lat
          + "&focus.point.lon=" + focus_lon;
    }

    return new Promise((resolve, reject) => {
      httpGET(url, null)
        .then((data) => {
          if (data === "") {
            reject("No data has been received");
          }
          const res = JSON.parse(data);
          const current_res = res.features;
          let search_from_results = [];
          for (const feature of res.features) {
            search_from_results.push(feature.properties.label);
          }
          resolve({ "current_res": current_res, "search_from_results": search_from_results })
        })
        .catch((err) => reject(err));
    });
  },

  reverseGeocode(lon, lat) {
    const url = OPENROUTESERVICE_URL + "/geocode/reverse?api_key=" + open_route_service_api_key
      + "&point.lon=" + encodeURIComponent(lon)
      + "&point.lat=" + encodeURIComponent(lat);

    return new Promise((resolve, reject) => {
      httpGET(url, null)
        .then((data) => {
          if (data === "") {
            reject("No data has been received");
          }
          const res = JSON.parse(data);
          if (res.features) {
            resolve({ loc_name: res.features[0].properties.label });
          }
        })
        .catch(err => reject(err));
    });
  }

};

const PhotonGeoCoder = {

  geocode(localization, focus_lat = null, focus_lon = null) {
    let url = PHOTON_SEARCH_URL + encodeURIComponent(localization);
    if (focus_lat && focus_lon) {
      url += "&lat=" + focus_lat
          + "&lon=" + focus_lon;
    }

    return new Promise(function (resolve, reject) {
      httpGET(url, null, (data) => {
        if (data === "") {
          reject("No data has been received");
        }
        const res = JSON.parse(data);
        const current_res = res.features;
        const search_from_results = [];
        for (const feature of res.features) {
          search_from_results.push(feature.properties.name + ", " + feature.properties.country);
        }
        resolve({ "current_res": current_res, "search_from_results": search_from_results });
      })
    });
  },

  reverseGeocode() {
    return new Promise((resolve, reject) => {
      reject("Not implemented with Photon API");
    })
  }

};


export const APIGeocode = {
  geocode(localization, focus_lat = null, focus_lon = null, service = GeocodeService.ORS) {
    switch (service) {
      default:
      case GeocodeService.ORS:
        return OpenRouteServicesGeoCoder.geocode(localization, focus_lat, focus_lon);
      case GeocodeService.PHOTON:
        return PhotonGeoCoder.geocode(localization, focus_lat, focus_lon);
    }
  },

  reverseGeocode(lon, lat) {
    return OpenRouteServicesGeoCoder.reverseGeocode(lon, lat);
  },
};